import { IPropertyListings } from '../data/entities/listing/listing';
import { _404 } from './handlers';
import { IConfiguredHttp } from './http';

export interface IListingsV2Api {
	getListingsByPropertyId: (id: number) => Promise<IPropertyListings[]>;
}

const listingsV2ApiFactory = (http: IConfiguredHttp, prefix = ''): IListingsV2Api => ({
	getListingsByPropertyId(id) {
		return http.get(`${prefix}/property/${id}/listings`).catch(_404([]));
	},
});

export default listingsV2ApiFactory;
